import { render, staticRenderFns } from "./SectionPointForm.vue?vue&type=template&id=25a72ff4"
import script from "./SectionPointForm.vue?vue&type=script&lang=js"
export * from "./SectionPointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports